class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  getSearchQuery() {
    const terms = this.getQuery()
      .replace(/[’`]/g, "'")
      .split(/\s+/)
      .map((term) => term.replace(/^['"]+|['"]+$/g, ''))
      .map((term) => term.replace(/^(?:[cdjlmnts]|qu)'/i, ''))
      .filter(Boolean);

    if (!terms.length) return '';

    return terms.map((term) => this.buildSearchTermExpression(term)).join(' AND ');
  }

  getSearchQueryVariants() {
    const query = this.getQuery().replace(/[’`]/g, "'");
    const terms = query
      .split(/\s+/)
      .map((term) => term.replace(/^['"]+|['"]+$/g, ''))
      .filter(Boolean);

    if (!terms.length) return [];

    if (terms.length > 1) {
      return [query, terms.map((term) => term.replace(/^(?:[cdjlmnts]|qu)'/i, '')).join(' ')];
    }

    const baseTerm = terms[0].replace(/^(?:[cdjlmnts]|qu)'/i, '');
    const variants = new Set([baseTerm]);

    if (baseTerm.length >= 4) {
      ['c', 'd', 'j', 'l', 'm', 'n', 's', 't', 'qu'].forEach((prefix) => {
        variants.add(`${prefix}'${baseTerm}`);
      });
    }

    return Array.from(variants);
  }

  buildSearchTermExpression(term) {
    const variants = new Set([term]);

    if (term.length >= 4) {
      ['c', 'd', 'j', 'l', 'm', 'n', 's', 't', 'qu'].forEach((prefix) => {
        variants.add(`${prefix}'${term}`);
      });
    }

    return `(${Array.from(variants)
      .map((variant) => `"${variant.replace(/"/g, '\\"')}"`)
      .join(' OR ')})`;
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
